// extracted by mini-css-extract-plugin
module.exports = {"status":"ReasonToUpload__status--2ebJH"};